// https://joshpitzalis.svbtle.com/crud
// https://medium.com/get-it-working/get-googles-firestore-working-with-react-c78f198d2364
// https://github.com/diegomura/react-pdf

import React, { Component } from 'react';
import { Header, Grid, Segment, Divider, Image, Container, Table } from 'semantic-ui-react'


import gscLogo from './media/logo-gex-ski-club.jpg';
import './PreRegisterForm.css';

var vendor = {};
var articles = {};

class PreRegisterConfirm extends Component {



        
    render() {
      console.log('render > vendor: ', this.props.vendor);
      console.log('render > vendor lastname: ', this.props.vendor.lastname);
      console.log('render > articles: ', this.props.articles);
      console.log('render > state: ', this.props.config);
      console.log('render > state: ', this.state);
      vendor = this.props.vendor;
      articles = this.props.articles;

        

  return(
    <div className="form-block">
    <Segment raised>
    <Grid stackable>
    <Grid.Row>
    <Grid.Column width={6}>
      <Image src={gscLogo} />
    </Grid.Column>
    <Grid.Column verticalAlign='middle' width={10}>
      <Header as='h1' content={this.props.config.txt_form_title} />
      <Header as='h2' content={this.props.config.txt_form_subtitle} />
    </Grid.Column>
    </Grid.Row>
    <Grid.Row>
    <Grid.Column textAlign='justified' width={16}>
    <br/><br/>
    <Header as='h3' textAlign='center'>Vos articles sont enregistrés!</Header>
    <br/><br/>
    <Header as='h4'>Numéro de pré-enregistrement : <b>{this.props.preregid}</b></Header>
    <br/><br/>
    <p>La procédure de pré-enregistrement est terminée.</p>
    <p>Le dépôt de matériel aura lieu le {this.props.config.txt_form_datetime_deposit}, salle Perdtemps de Gex. Il vous devez vous munir:</p>
    <ol>
    <li> de votre numéro de pré-enregistrement : <b>{this.props.preregid}</b></li>
    <li> de votre justificatif d'identité</li>
    <li> du matériel que vous venez déposer</li>
    </ol>

    {/*<p>Vous pouvez télécharger le document récapitulatif</p>*/}
    {/*<p>Vous recevrez une confirmation par email dans les prochaines minutes.</p>*/}
    <p>Vous trouverez <a target="_blank" rel="noopener noreferrer" href={this.props.config.txt_form_more_info_link}>ici plus d'information sur le déroulement de la bourse aux ski</a>.</p>
    Récapitulatif des informations transmises:<br/><br/>
    </Grid.Column>
    </Grid.Row>
    </Grid>
  <Divider hidden />

    <Container>
<Grid compact>
<Grid.Row color='orange'>
<Grid.Column width={16}>NUMERO DE PRE-ENREGISTREMENT: <b>{this.props.preregid}</b></Grid.Column>
</Grid.Row>
<Grid.Row>
<Grid.Column width={8}>Prénom: <b>{vendor.firstname}</b></Grid.Column>
<Grid.Column width={8}>Nom: <b>{vendor.lastname}</b></Grid.Column>
</Grid.Row>
<Grid.Row>
<Grid.Column width={16}>Email: <b>{vendor.email}</b></Grid.Column>
</Grid.Row>
<Grid.Row><Grid.Column width={4}>Adresse postale:</Grid.Column><Grid.Column width={12}><b>{vendor.address_1}</b></Grid.Column></Grid.Row>
{(vendor.address_2 !== 'undefined') ? <Grid.Row><Grid.Column only='computer tablet' width={4}></Grid.Column><Grid.Column width={12}><b>{vendor.address_2}</b></Grid.Column></Grid.Row> : null}
{(vendor.address_3 !== 'undefined') ? <Grid.Row><Grid.Column only='computer tablet' width={4}></Grid.Column><Grid.Column width={12}><b>{vendor.address_3}</b></Grid.Column></Grid.Row> : null}
<Grid.Row>
<Grid.Column width={4}>Code Postal: <b>{vendor.zipcode}</b></Grid.Column>
<Grid.Column width={5}>Ville: <b>{vendor.city}</b></Grid.Column>
<Grid.Column width={7}>Pays: <b>{vendor.countrycode}</b></Grid.Column>
</Grid.Row>
<Grid.Row>
<Grid.Column width={8}>Justificatif d'identité: <b>{vendor.idtype}</b></Grid.Column>
<Grid.Column width={8}>Numéro: <b>{vendor.idnumber}</b></Grid.Column>
</Grid.Row>
</Grid>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Article</Table.HeaderCell>
            <Table.HeaderCell>Description</Table.HeaderCell>
            <Table.HeaderCell>Prix (euros)</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {
          articles.map((val, idx)=> {
          return (
          <Table.Row>
          <Table.Cell>{idx+1}</Table.Cell>
          <Table.Cell> {val.description}</Table.Cell>
          <Table.Cell>{val.price}</Table.Cell>
          </Table.Row>
          )
          })
          }
        </Table.Body>
      </Table>
    </Container>
    <Divider hidden />
  </Segment>
  </div>
)
  }
}

export default PreRegisterConfirm;
